<template>
    
    <div class="h-12 w-full flex flex-row mt-2" :class="{'shadow-inner bg-blue-100': storeSelected == data.id}" @click="activeStore(data.id)">
        <div class="h-full w-1/6 flex flex-col justify-center items-center">
            <div class="h-8 w-8 rounded-full bg-green-300 flex flex-col justify-center items-center">
                <span class="text-white text-xl">€</span>
            </div>
        </div>
        <div class="h-full w-5/6 border-b border-gray-300">
            <div class="h-1/3 w-full flex flex-row justify-between items-center pr-2">
                <span class="text-lg text-gray-800 font-semibold w-1/3">{{data.name}}</span>
                <span class="text-lg text-gray-600">{{data.average_ticket | reduceBigNumbers()}}€</span>
                <span class="text-lg text-gray-600 w-1/3 text-right">{{data.current | reduceBigNumbers() }}€</span>
            </div>
            <div class="h-1/3 w-full flex flex-row justify-between items-center pr-2">
                <span class="text-xs" :class="{'text-green-400': data.growth >= 0, 'text-red-400': data.growth < 0}">{{data.growth}}%</span>
                <span class="text-xs text-gray-600">{{data.previous | reduceBigNumbers() }}€</span>
            </div>
        </div>
    </div>
</template>

<script>
import { state,actions } from '../store/store.js';

export default {
    props:['data'],
    methods:{
        activeStore(store){
            if(state.store == store){
                actions.setStore(null)
            } else {
                actions.setStore(store)
            }
        }
    },
    computed:{
        storeSelected(){
            return state.store
        }
    }
}
</script>